import { render, staticRenderFns } from "./modalVerCategorias.vue?vue&type=template&id=bee4df9a"
import script from "./modalVerCategorias.vue?vue&type=script&lang=js"
export * from "./modalVerCategorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports